<template>
  <div class="home">
    <div class="bannerSwiper-box">
      <swiper class="bannerSwiper" :options="bannerOptions">
        <swiper-slide v-for="item in bannerList">
          <img :src="item" alt="" class="banner" />
        </swiper-slide>
      </swiper>
      <div class="fraction" slot="pagination">
        <span>{{
          bannerOptionsActive > 10
            ? bannerOptionsActive
            : '0' + bannerOptionsActive
        }}</span
        >/
        <span>{{
          bannerList.length > 10 ? bannerList.length : '0' + bannerList.length
        }}</span>
      </div>
    </div>
    <div class="wrapper first">
      <p class="title">兴致力为您提供服务</p>
      <p class="sub-title">Xing Z LI ceso provide you with services</p>
      <div class="box">
        <template v-for="item in serviceLst">
          <router-link
            tag="div"
            class="box-detail"
            :to="{
              path: '/detail',
              query: { api: 'server_details', id: item.id },
            }"
            :style="{ backgroundImage: 'url(' + item.img + ')' }"
          >
            <img src="../assets/box-detail.png" class="bg" />
            <p class="name">{{ item.title }}</p>
            <p class="desc">{{ item.en_title }}</p>
            <div class="after">
              <p class="name">{{ item.title }}</p>
              <p class="desc">{{ item.en_title }}</p>
              <router-link to=""
                >MORE <i class="el-icon-arrow-right"></i>
              </router-link>
            </div>
          </router-link>
        </template>
      </div>
    </div>
    <!-- 公司简介 -->
    <inroduction :over="true" :data="company_profile" />
    <div class="third">
      <div class="wrapper">
        <p class="pub-title">最新动态</p>
        <p class="pub-sub-title">Latest News</p>
        <div class="news">
          <router-link
            tag="div"
            :to="{
              path: '/detail',
              query: { api: 'news_details', id: news_left.id },
            }"
            class="left"
          >
            <div class="new-img-box"><img :src="news_left.img" alt="" /></div>
            <p class="name">{{ news_left.title }}</p>
            <p class="content">
              {{ filterText(news_left.intro, 50) }}
            </p>
          </router-link>
          <ul class="right">
            <router-link
              :to="{
                path: '/detail',
                query: { api: 'news_details', id: item.id },
              }"
              tag="li"
              v-for="(item, index) in news"
              :key="index"
            >
              <div class="date">
                <p class="year">{{ item.year }}</p>
                <p class="day">{{ item.md }}</p>
              </div>
              <div class="inner">
                <p class="name">{{ item.title }}</p>
                <p class="content">
                  {{ filterText(item.intro, 50) }}
                </p>
              </div>
            </router-link>
          </ul>
        </div>
      </div>
    </div>
    <div class="fourth">
      <div class="wrapper">
        <p class="pub-title">合作伙伴</p>
        <p class="pub-sub-title">Partner</p>
        <div class="swiper-box">
          <swiper :options="options" ref="swiper">
            <swiper-slide v-for="(item, index) in honor_customer">
              <img :src="item.img" alt="" />
            </swiper-slide>
          </swiper>
          <p class="dot"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import {
  banner,
  server,
  company_profile,
  news_news,
  honor_customer,
  news_top,
} from '../utils/api'
import inroduction from '@/components/about/introduction'
export default {
  name: 'Home',
  components: { inroduction },
  data() {
    let that = this
    return {
      bannerOptionsActive: 1,
      bannerOptions: {
        autoplay: true,
        pagination: {
          height: '660px',
          // el: '.fraction',
          // type: 'fraction',
        },
        on: {
          slideChangeTransitionStart() {
            that.bannerOptionsActive = this.realIndex + 1
          },
        },
      },
      options: {
        spaceBetween: 39,
        slidesPerColumnFill: 'row',
        slidesPerView: 4,
        slidesPerColumn: 3,
        centerInsufficientSlides: true,
        pagination: {
          el: '.dot',
          bulletClass: 'dots',
          bulletActiveClass: 'dots-active',
          clickable: true,
        },
      },
      actives: 0,
      bannerList: [], //banner列表
      serviceLst: [], //服务列表
      company_profile: {}, //公司简介
      news: [], // 新闻-右边
      news_left: {}, //新闻-左边
      honor_customer: [],
    }
  },
  created() {
    if (/(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent)) {
      this.options.slidesPerView = 2
      this.options.slidesPerColumn = 2
      this.options.spaceBetween = 16
    }
  },
  mounted() {
    // banner
    banner((r) => {
      console.log(r)
      this.bannerList = r.data
    })
    // 服务列表
    server((r) => {
      this.serviceLst = r.data.slice(0, 4)
    })
    news_top((r) => {
      this.news_left = r.data
    })
    // 最新新闻
    news_news((r) => {
      this.news = r.data.slice(0, 5)
    })
    // 合作伙伴
    honor_customer((r) => {
      this.honor_customer = r.data.data
    })
  },
}
</script>

<style lang="less" scoped>
.dot {
  text-align: center;
  margin-top: 40px;
}
.bannerSwiper-box {
  position: relative;
  .fraction {
    position: absolute;
    z-index: 1;
    padding-left: 360px;
    bottom: 12px;
    font-size: 18px;
    font-family: DIN;
    font-weight: 400;
    line-height: 22px;
    color: #ffffff;
    span:first-child {
      font-size: 48px;
      font-family: DIN;
      font-weight: 400;
      line-height: 58px;
      color: #006C8F;
    }
  }
}
/deep/.dots {
  width: 40px;
  height: 10px;
  background: #c8c8c8;
  display: inline-block;
  margin-right: 20px;
  transition: all 0.15s linear;
}
/deep/.dots:last-child {
  margin-right: 0;
}
/deep/.dots-active {
  background: #006C8F !important;
}

.home {
  .wrapper {
    padding: 80px 0;
  }

  .first {
    text-align: center;

    .title {
      font-size: 30px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      line-height: 40px;
      color: #1a1a1a;
    }

    .sub-title {
      font-size: 22px;
      font-family: Arial;
      font-weight: 400;
      line-height: 26px;
      color: #909090;
      padding: 10px 0;
      position: relative;
      margin-bottom: 40px;
    }

    .sub-title::after {
      content: ' ';
      width: 120px;
      height: 4px;
      background: #006C8F;
      border-radius: 1px;
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
    }

    .box {
      display: flex;
      justify-content: space-between;

      .box-detail {
        width: 270px;
        height: 436px;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        background-repeat: no-repeat;
        background-size: cover;
        position: relative;
        cursor: pointer;
        padding: 40px;
        box-sizing: border-box;
        overflow: hidden;

        .name {
          font-size: 22px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: 29px;
          color: #ffffff;
          margin-bottom: 10px;
        }

        p {
          width: 100%;
          text-align: center;
          color: #ededed;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          position: relative;
          z-index: 1;
        }

        .name {
          font-size: 22px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;
        }

        .desc {
          font-size: 12px;
          font-family: Arial;
          font-weight: 400;
        }

        img {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
        }

        .after {
          transition: all 0.15s linear;
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          z-index: 1;
          background: rgba(2, 178, 181, 0.5);
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          transition: 0.15s linear;
          transform: translateY(100%);

          a {
            margin-top: 38px;
            font-size: 18px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #ffffff;
            text-decoration: none;
            position: relative;
          }
          a::after {
            width: 100%;
            height: 100%;
            content: '';
            position: absolute;
            left: 0;
            bottom: 0;
            transform: translateY(-100%);
            transition: all 0.15s linear;
          }
          a:hover {
            text-decoration: underline;
            color: white;
          }
        }
      }

      .box-detail:hover {
        & > p {
          display: none;
        }

        .after {
          transform: translateY(0);
        }
      }
    }
  }

  .third {
    background-image: url('../assets/home_news.png');
    background-size: cover;
    background-repeat: no-repeat;

    .wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;

      .news {
        display: flex;
        justify-content: space-between;
        margin-top: 40px;
        width: 100%;
        .name {
          font-size: 22px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: 29px;
          color: #1a1a1a;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          width: 100%;
          transition: all 0.15s linear;
        }

        .content {
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: 24px;
          color: #909090;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          transition: all 0.15s linear;
        }

        .left {
          width: 636px;
          padding-right: 80px;
          box-sizing: border-box;
          cursor: pointer;
          position: relative;
          .name {
            margin: 20px 0;
          }
          .new-img-box {
            overflow: hidden;
            width: 100%;
            height: 347px;
          }
          img {
            width: 100%;
            height: 347px;
            vertical-align: middle;
            transition: all 0.15s linear;
          }
        }
        .left:hover {
          img {
            transform: scaleX(1.2) scaleY(1.2);
          }
        }
        .left:hover,
        li:hover {
          .name,
          .content {
            color: #006C8F;
          }
        }
        li:hover::after {
          width: 100%;
        }
        li::after {
          content: '';
          width: 0%;
          height: 0;
          position: absolute;
          border-bottom: 2px solid #c8c8c8;
          transition: all 0.3s linear;
          left: 0;
          bottom: -10px;
        }
        ul {
          width: calc(100% - 636px);

          li:last-child {
            margin-bottom: 0;
          }
          li {
            display: flex;
            align-items: center;
            margin-bottom: 40px;
            cursor: pointer;
            position: relative;
            .date {
              margin-right: 40px;

              .year {
                font-size: 36px;
                font-family: DIN;
                font-weight: 400;
                line-height: 43px;
                color: #006C8F;
                margin-bottom: 10px;
              }

              .day {
                font-size: 22px;
                font-family: DIN;
                font-weight: 400;
                line-height: 27px;
                color: #006C8F;
                text-align: center;
              }
            }

            .inner {
              width: calc(100% - 130px);
              .name {
                width: 100%;
                margin-bottom: 10px;
              }
            }
          }
        }
      }
    }
  }
  .fourth {
    background: #fafafa;
    .wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
      .swiper-box {
        width: 1200px;
        margin-top: 39px;
        img {
          width: 100%;
          height: 163px;
        }
      }
    }
  }
}
@media (max-width: 767px) {
  .bannerSwiper-box {
    position: relative;
    .fraction {
      padding-left: 0.68rem;
      bottom: 0.12rem;
      font-size: 0.2rem;
      color: #ffffff;
      span:first-child {
        font-size: 0.28rem;
        color: #006C8F;
      }
    }
  }
  .home {
    padding-top: 0.88rem;
    .banner {
      height: 2.6rem;
    }
    .first {
      padding: 0.68rem 0.34rem;
      box-sizing: border-box;
      .title {
        font-size: 0.4rem;
        line-height: 0.4rem;
      }
      .sub-title {
        font-size: 0.28rem;
        padding: 6px 0;
        margin-bottom: 0.34rem;
        line-height: 0.32rem;
      }
      .sub-title::after {
        width: 1.2rem;
      }
      .box {
        flex-wrap: wrap;
        .box-detail {
          width: 3.24rem;
          height: 5.32rem;
          padding: 0.24rem 0.26rem;
          margin-bottom: calc(100% - 3.24rem - 3.24rem);
          .name {
            font-size: 0.28rem;
            margin-bottom: 0.12rem;
          }
          .desc {
            font-size: 0.2rem;
          }
        }
      }
    }
    .second {
      padding: 0.68rem 0.34rem;
      background-image: url('../assets/bg_city1.png');
      .right {
        display: none;
      }
    }
    .third {
      .wrapper {
        padding: 0.68rem 0;
        box-sizing: border-box;
        display: block;
        padding-bottom: 0;
        .news {
          display: block;
          margin-top: 0.34rem;
          .left {
            width: 100%;
            padding-right: 0;
            padding: 0 0.34rem;
            padding-bottom: 0.34rem;
            box-sizing: border-box;
            border-bottom: 0.2rem solid #f5f5f5;
            .name {
              margin: 0.24rem 0;
              line-height: 0.32rem;
            }
            .new-img-box {
              height: 4.26rem;
            }
            img {
              height: 4.26rem;
            }
          }
          .content {
            font-size: 0.26rem;
          }
          .name {
            font-size: 0.32rem;
            margin: 0.24rem 0;
            line-height: 0.32rem;
          }
          .right {
            width: 100%;
            padding: 0.34rem;
            box-sizing: border-box;
            .date {
              margin-right: 0.34rem;
              .year {
                font-size: 0.48rem;
                line-height: 0.38rem;
              }
              .day {
                font-size: 0.24rem;
                line-height: 0.3rem;
              }
            }
          }
          ul {
            li:last-child {
              border-bottom: none;
            }
            li {
              padding-bottom: 0.34rem;
              border-bottom: 1px solid #c8c8c8;
              margin-bottom: 0.34rem;
              .inner {
                width: calc(100% - 0.96rem - 0.34rem);
                .name {
                  margin-bottom: 0.24rem;
                }
              }
            }
          }
        }
      }
    }
    .fourth {
      padding: 0.68rem 0.34rem;
      box-sizing: border-box;
      .wrapper {
        padding: 0;
        .swiper-box {
          width: 100%;
          margin-top: 0.34rem;
          img {
            height: 100%;
            vertical-align: middle;
          }
        }
      }
    }
  }
  /deep/.dots {
    width: 0.4rem;
    height: 0.1rem;
    background: #c8c8c8;
    display: inline-block;
    margin-right: 20px;
    transition: all 0.15s linear;
  }
  .dot {
    text-align: center;
    font-size: 0;
    margin-top: 0.34rem;
  }
  /deep/.bannerSwiper {
    .fraction {
      padding-left: 0.68rem;
      bottom: 0.12rem;
      font-size: 0.2rem;
      line-height: 0.24rem;
      .swiper-pagination-current {
        font-size: 0.28rem;
        color: #006C8F;
      }
    }
  }
}
</style>
